var map = {
	"./backtop.svg": 73571,
	"./copy.svg": 25661,
	"./good.svg": 76560,
	"./qq.svg": 72576,
	"./save.svg": 65337,
	"./search.svg": 42052,
	"./share.svg": 2242,
	"./star.svg": 46189,
	"./user.svg": 28806,
	"./wechat.svg": 71631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;